import React from "react";
import FleetFailureImpactEvolution from "./Charts/FleetFailureImpactEvolution";
import FleetFailureImpactByReparabilityMatrix from "./Charts/FleetFailureImpactByReparabilityMatrix";
import EmptyReporting from "../EmptyReporting";
import { useDiagnosisReporting } from "../../../../api/useReporting";

export const ReportingDiagnosis = () => {
  const reporting = useDiagnosisReporting();
  if (reporting.periods.length === 0) return <EmptyReporting reporting={reporting} />;
  return (
    <>
      <FleetFailureImpactEvolution reporting={reporting} />
      <FleetFailureImpactByReparabilityMatrix reporting={reporting} />
    </>
  );
};
